import { Account } from '@mkp/account/models';
import { GlobalCategory } from '@mkp/tracking/models';
import { User } from '@mkp/user/models';
import { getCompanyCategory } from './helpers/get-company-category';
import { getAuthenticatedUserCategory, getVisitorUserCategory } from './helpers/get-user-category';

export const getGlobalCategory = (
  user: Pick<User, 'email' | 'id' | 'settings'> | null | undefined,
  account: Account | undefined
): GlobalCategory =>
  user
    ? account
      ? {
          ...getAuthenticatedUserCategory(user, account),
          ...getCompanyCategory(account.legalEntity),
        }
      : getAuthenticatedUserCategory(user, account) // no-company case is during onboarding
    : getVisitorUserCategory();
